import { FunctionComponent } from 'react'
import { LiveEventTransformedTennis } from '@utils/formatters/tennis'
import SportsHeaderComponents from '@components/Teaser/SportsHeader'
import InfoTitle from './InfoTitle'

const {
  BottomPart,
  HalvesHeader,
  LeftHalf,
  LiveStatusTitle,
  MiddleInfo,
  HalvesInfo,
  RightHalf,
  StatusTitle,
  TennisScoreTable,
  TopBottomHeader,
  TopPart,
} = SportsHeaderComponents

interface HeaderTennisProps {
  data: LiveEventTransformedTennis
}

const HeaderTennis: FunctionComponent<HeaderTennisProps> = ({ data }) => {
  const {
    willStart,
    isCancelled,
    isLive,
    statusTitle,
    competitors,
    period_scores: tennisGamesCompleted,
    game_state: tennisGameInProgress,
  } = data

  const [homePlayer, awayPlayer] =
    competitors && competitors.length ? competitors : [null, null]

  const hasEnded = !willStart && !isLive
  const hasBeenStarted = !willStart

  if (!homePlayer || !awayPlayer) {
    return null
  }

  if (!hasBeenStarted || isCancelled) {
    return (
      <HalvesHeader>
        <LeftHalf>
          <HalvesInfo align="left">{homePlayer.name}</HalvesInfo>
        </LeftHalf>

        <MiddleInfo infoTitleShown={true}>
          <InfoTitle isLive={false}>{statusTitle}</InfoTitle>
        </MiddleInfo>

        <RightHalf>
          <HalvesInfo align="right">{awayPlayer.name}</HalvesInfo>
        </RightHalf>
      </HalvesHeader>
    )
  }

  return (
    <TopBottomHeader>
      <TopPart>
        {isLive ? <LiveStatusTitle>{statusTitle}</LiveStatusTitle> : null}
        {!hasEnded && !isLive ? <StatusTitle>{statusTitle}</StatusTitle> : null}
      </TopPart>
      <BottomPart>
        <TennisScoreTable
          homePlayer={homePlayer}
          awayPlayer={awayPlayer}
          tennisGamesCompleted={tennisGamesCompleted}
          tennisGameInProgress={tennisGameInProgress}
        />
      </BottomPart>
    </TopBottomHeader>
  )
}

export default HeaderTennis
